/** Loads a card's deferred hover image (img[data-hover-src]) on first pointer or focus intent and reveals it once decoded. */

const CARD = '.product-card-editorial, .product-wheel-card, .ca-quick-add-host';
const canHover = window.matchMedia('(hover: hover)');

/** @param {HTMLImageElement} img */
function reveal(img) {
  img.removeAttribute('data-hover-src');
}

/**
 * @param {string} src - Shopify image URL carrying a width= parameter.
 * @param {string} widths - Comma-separated widths.
 */
export function buildSrcset(src, widths) {
  return widths
    .split(',')
    .map((width) => width.trim())
    .filter(Boolean)
    .map((width) => `${/[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, `$1width=${width}`) : `${src}${src.includes('?') ? '&' : '?'}width=${width}`} ${width}w`)
    .join(', ');
}

/** @param {HTMLImageElement} img */
function loadHoverImage(img) {
  if (img.hasAttribute('src')) return;
  const src = img.getAttribute('data-hover-src') || '';
  const widths = img.getAttribute('data-hover-widths');
  img.loading = 'eager';
  img.fetchPriority = 'high';
  if (widths) img.srcset = buildSrcset(src, widths);
  img.removeAttribute('data-hover-widths');
  img.addEventListener('load', () => reveal(img), { once: true });
  img.src = src;
  img.decode().then(
    () => reveal(img),
    () => {
      if (img.complete && img.naturalWidth > 0) reveal(img);
    }
  );
}

/** @param {Event} event */
function onIntent(event) {
  if (!canHover.matches) return;
  if (/** @type {PointerEvent} */ (event).pointerType === 'touch') return;
  const target = event.target;
  if (!(target instanceof Element)) return;
  const card = target.closest(CARD);
  if (!card) return;
  const img = card.querySelector('img[data-hover-src]');
  if (img instanceof HTMLImageElement) loadHoverImage(img);
}

document.addEventListener('pointerover', onIntent, { passive: true });
document.addEventListener('focusin', onIntent);
